import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { ScrollToTop } from "./components/ScrollToTop";

const Home = lazy(() => import("./pages/Home").then(m => ({ default: m.Home })));
const ShopDetail = lazy(() => import("./pages/ShopDetail").then(m => ({ default: m.ShopDetail })));
const UserProfile = lazy(() => import("./pages/UserProfile").then(m => ({ default: m.UserProfile })));
const Admin = lazy(() => import("./pages/Admin").then(m => ({ default: m.Admin })));
const CityHub = lazy(() => import("./pages/City").then(m => ({ default: m.CityHub })));
const ShopAdmin = lazy(() => import("./pages/ShopAdmin").then(m => ({ default: m.ShopAdmin })));
const Leaderboard = lazy(() => import("./pages/Leaderboard").then(m => ({ default: m.Leaderboard })));
const Contact = lazy(() => import("./pages/Contact").then(m => ({ default: m.Contact })));
const ClaimShop = lazy(() => import("./pages/ClaimShop").then(m => ({ default: m.ClaimShop })));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy").then(m => ({ default: m.PrivacyPolicy })));
const CookiePolicy = lazy(() => import("./pages/CookiePolicy").then(m => ({ default: m.CookiePolicy })));
const TermsOfService = lazy(() => import("./pages/TermsOfService").then(m => ({ default: m.TermsOfService })));
const ListingDisclaimer = lazy(() => import("./pages/ListingDisclaimer").then(m => ({ default: m.ListingDisclaimer })));
const CompanyInfo = lazy(() => import("./pages/CompanyInfo").then(m => ({ default: m.CompanyInfo })));
const NotFound = lazy(() => import("./pages/NotFound").then(m => ({ default: m.NotFound })));
const Favorites = lazy(() => import("./pages/Favorites").then(m => ({ default: m.Favorites })));
const Blog = lazy(() => import("./pages/Blog").then(m => ({ default: m.Blog })));
const BlogPost = lazy(() => import("./pages/BlogPost").then(m => ({ default: m.BlogPost })));

function PageSpinner() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="w-8 h-8 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<PageSpinner />}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/shop-admin/:id" element={<ShopAdmin />} />
            <Route path="/cities/:city" element={<CityHub />} />
            <Route path="/cities/:city/:slug" element={<ShopDetail />} />
            <Route path="/cities/:city/:neighborhood/:slug" element={<ShopDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/claim/:shopId" element={<ClaimShop />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/disclaimer" element={<ListingDisclaimer />} />
            <Route path="/company-info" element={<CompanyInfo />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
